<template>
<div class="astrology_forget_password astrology-auth-container  ">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto" id="astrologyFormDiv">
          <!-- <Login titleH2="Do.OmYoga! <br> STUDIO" guard="DY" clientLink="doom_yoga" /> -->
          <!-- <ForgetPassword
            titleH2="Do.OmYoga! <br> STUDIO"
            welcomeHeader="Reset Passsword"
            welcomeSubheader="Please enter your registered email to send you an link to reset your password"
            guard="DY" clientLink="doom_yoga"
          /> -->
          <ResetPassword
             guard="AV"
             logoSrc="astrology/av-logo-auth.png"
            clientLink="astrology_ventures"
            welcomeHeader="Reset Passsword"
            welcomeSubheader="Enter your new password to log in to your account now."
           :token="$route.query.token"
            :email="$route.query.email"
          />
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from "@/components/auth/ResetPassword.vue";

export default {
  name: "AstrologyResetPassword",
  components: { ResetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit reset password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/astrology-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/astrology_ventures/auth/ResetPasswordView.vue